export const HRV_NORMAL_RANGES = {
    hr: [60, 100] as const,
    sdnn: [50, 150] as const,
    rmssd: [20, 50] as const,
    pnn50: [10, 20] as const,
    pnn20: [20, 50] as const,
};

export type HrvTone = 'green' | 'darkgreen' | 'goldenrod' | 'red';

export const hrvTone = (value: number, range: readonly [number, number], isHr = false): HrvTone => {
    const [lo, hi] = range;
    if (isHr) {
        if (lo * 0.9 <= value && value <= hi * 1.1) return 'green';
        if ((lo * 0.8 <= value && value < lo * 0.9) || (hi * 1.1 < value && value <= hi * 1.2)) {
            return 'goldenrod';
        }
        return 'red';
    }
    if (lo <= value && value <= hi) return 'green';
    if (value > hi) return 'darkgreen';
    if (lo * 0.8 <= value && value < lo) return 'goldenrod';
    return 'red';
};

export const toneColor = (tone: HrvTone): string => {
    switch (tone) {
        case 'green':
            return '#2e7d32';
        case 'darkgreen':
            return '#1b5e20';
        case 'goldenrod':
            return '#daa520';
        default:
            return '#c62828';
    }
};
